import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=bb752304&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=ts"
export * from "./DownloadButton.vue?vue&type=script&lang=ts"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=bb752304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb752304",
  null
  
)

export default component.exports